import { AuthenticationUserType, AuthorityType, TFunction, axiosInstance, saveFile } from "@fides/fides-react-components";
import _ from "lodash";
import { ADMIN_PRIVILEGE_ID, CASHPOOL_MODULE_ID } from "../constants/constant";
import { API_ENDPOINTS } from "../constants/ApiEndpoints";
import { AxiosRequestConfig, AxiosResponseHeaders } from 'axios';

export interface FilterParams {
  key: string;
  values: any[];
  valueFormatter?: (param: { value: any }) => TFunction;
}

export const getUserAuthority = (authorityModule: string, user: AuthenticationUserType | undefined) =>
  user?.authorities?.find((authority: AuthorityType) => ((authority.module && authority.module === authorityModule) || authority.authority === authorityModule));


export const checkFidesAdmin = (user: AuthenticationUserType | undefined) => {
  let isFidesAdmin = false;
  if (_.isObject(user)) {
    isFidesAdmin = _.isObject(_.find(user.authorities, {authority: 'EFTWeb:FidesAdministrator'}));
  }
  return isFidesAdmin;
};

export const checkIfAnyFidesAdmin = (user: AuthenticationUserType | undefined) => {
  let isAnyFidesAdmin = false;
  if (_.isObject(user)) {
    isAnyFidesAdmin = _.isObject(_.find(user.authorities, {authority: 'EFTWeb:FidesAdministrator'}))
    || _.isObject(_.find(user.authorities, {authority: 'EFTWeb:FidesReadOnlyAdministrator'}));
  }
  return isAnyFidesAdmin;
};

export const checkCSAdmin = (user: AuthenticationUserType | undefined) => {
  let isCSAdmin = false;
  if (_.isObject(user)) {
    const cashPoolAuthority = getUserAuthority(CASHPOOL_MODULE_ID, user);
    isCSAdmin = !_.isUndefined(cashPoolAuthority) && cashPoolAuthority.privilege === ADMIN_PRIVILEGE_ID;
  }
  return isCSAdmin;
};

export const checkCSClient = (staticData: any) => {
  return (staticData?.isCSClient[0]+'').toLowerCase() === "true"
}

export const getPortalUser = (user: AuthenticationUserType | undefined) => {
  return {
    username: user?.username,
    client: user?.client,
    domainUser: user?.domainUser,
    authorities: user?.authorities || [],
    userGroups: [],
    impersonated: checkIfAnyFidesAdmin(user) && _.isObject(user?.impersonatedClient),
    impersonatedUser: user?.impersonatedUser,
    impersonatedClient: user?.impersonatedClient,
    isCSClient: user?.isCSClient,
    applications: [],
  }
}

export const downloadZippedReports = async (
  uuids: string[] | null,
  filter: FilterParams,
  fileName?: string,
) => {
  fileName = fileName ?? `reports-${new Date().toISOString()}.zip`;
  return downloadFile(
    { url: API_ENDPOINTS.documents.downloadZip,
      responseType: 'blob', 
      method: 'POST',
      data: { 
        ...(uuids && { uuids }), 
        ...(filter && { filter }) 
      } 
    },
    fileName
  );
};

export const downloadReport = async (uuid: string, fileName: string) => {
  return downloadFile(
    {
      url: `${API_ENDPOINTS.documents.download}?uuid=${uuid}`,
      responseType: 'blob'
    },
    fileName
  );
};

export async function downloadFile(
  config: AxiosRequestConfig,
  fileName: string
) {
  return axiosInstance({
    method: 'GET',
    ...config
  }).then(response => saveFile(response.data as BlobPart, fileName + extension(response.headers)))
}

export function extension(headers: AxiosResponseHeaders) {
  return headers['filetype'] ? '.' + headers['filetype'] : '';
}